import * as _4 from 'lodash4';
import { IContentTileActionObj, IContentTileIconObj, IContentTileTextObj } from 'ui-ng-content-tile';
import { MajorExplorerCapabilityConfiguration } from '../../configuration';
import { MajorDataToggleService } from '../../data/services/major_data_toggle_service';
import { MajorCurrentMajorsQuery } from './../../data/queries/major_current_majors_query';

interface ISurveyBeginFlag {
  majorExplorerCompleted: boolean;
  hasPlacementBands: boolean;
}

interface ISurveyBeginModel {
  name: string;
}

interface IContentTileConfig {
  icon: IContentTileIconObj;
  text: IContentTileTextObj;
  action: IContentTileActionObj;
}

export class SurveyBeginViewContentController {
  private model: ISurveyBeginModel;
  private flags: ISurveyBeginFlag;
  private intakeItem: any;
  private surveyTakenConfig: IContentTileConfig;
  private surveyBeginNoMajorConfig: IContentTileConfig;
  private surveyCompletedConfig: IContentTileConfig;
  private placementScoreConfig: IContentTileConfig;

  constructor(
    private $stateParams: ng.ui.IStateParamsService,
    private accountModel: any,
    private ngMajorCurrentMajorsQuery: MajorCurrentMajorsQuery,
    private myIntakeModel: any,
    private majorDataToggleService: MajorDataToggleService,
    private ngMajorExplorerCapabilityConfiguration: MajorExplorerCapabilityConfiguration
  ) {}

  $onInit(): void {
    const SERVER_PLACEMENT_BAND_STRATEGY = `PlacementBand`;
    this.model = {
      name: this.accountModel.firstName
    };
    this.flags = {
      majorExplorerCompleted: this.intakeItem.source.task.status === 'COMPLETED',
      hasPlacementBands:
        this.ngMajorExplorerCapabilityConfiguration.config.devReqStrategy === SERVER_PLACEMENT_BAND_STRATEGY
    };
    this.configureContentTileSettings();
  }

  hasCurrentMajors(): boolean {
    return (
      this.ngMajorCurrentMajorsQuery.result.length > 0 &&
      _4.first(this.ngMajorCurrentMajorsQuery.result).nk !== '*UNDECLARED*'
    );
  }

  configureContentTileSettings(): void {
    const DEFAULT_STATE = 'my.majorexplorer-step';

    this.surveyTakenConfig = {
      icon: {
        type: 'graduation',
        theme: 'teal'
      },
      text: {
        title: 'Take the Major Explorer survey again',
        subTitle: 'Update your goals and interests to explore different potential majors'
      },
      action: {
        state: DEFAULT_STATE,
        params: {
          pageIndex: 0,
          fromState: this.$stateParams.fromState
        }
      }
    };

    this.surveyBeginNoMajorConfig = {
      icon: {
        type: 'graduation',
        theme: 'teal'
      },
      text: {
        title: 'Take the Major Explorer survey',
        subTitle: 'Enter your goals and interests to explore potential majors'
      },
      action: {
        state: DEFAULT_STATE,
        params: {
          pageIndex: 0,
          fromState: this.$stateParams.fromState
        }
      }
    };

    this.surveyCompletedConfig = {
      icon: {
        type: 'check',
        theme: 'green'
      },
      text: {
        title: 'View your Major Explorer survey results',
        subTitle: 'Look at majors and careers that might fit your interests'
      },
      action: {
        state: DEFAULT_STATE,
        params: {
          pageIndex: this.myIntakeModel.progression.size() - 1,
          fromState: this.$stateParams.fromState
        }
      }
    };

    this.placementScoreConfig = {
      icon: {
        type: 'apple_and_checkmark',
        theme: 'blue'
      },
      text: {
        title: 'View your Placement Test results',
        subTitle: 'Placement tests can determine if you need to take developmental courses'
      },
      action: {
        state: 'my.placementscores',
        params: {}
      }
    };
  }
}

export class SurveyBeginViewContentComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/survey_begin_view_content/survey_begin_view_content.html';
  public controller: any = SurveyBeginViewContentController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    intakeItem: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/survey_begin_view_content/survey_begin_view_content_controller.ts